import { SettingsPermissions } from "@redotech/account-common/permissions";
import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { IntegrationsHubRedirect } from "../integrations-hub-redirect";

export const marketingSettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      get breadcrumb() {
        return t("Attribution");
      },
      permission: SettingsPermissions.SET_MARKETING_SETTINGS,
    },
    path: "attribution",
    lazy: async () => {
      const { AttributionSettingsPage } =
        await import("../../../../setting/attribution/attribution-settings");
      return { Component: AttributionSettingsPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Audience");
      },
      permission: SettingsPermissions.SET_MARKETING_SETTINGS,
    },
    path: "audience",
    lazy: async () => {
      const { AudienceSettingsPage } =
        await import("../../../../setting/marketing/audience-settings");
      return { Component: AudienceSettingsPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Email Domain");
      },
      permission: SettingsPermissions.SET_MARKETING_SETTINGS,
    },
    path: "email-domain",
    lazy: async () => {
      const { EmailDomainPage } =
        await import("../../../../setting/marketing/email-domain/email-domain");
      return { Component: EmailDomainPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Integrations");
      },
      permission: SettingsPermissions.SET_MARKETING_SETTINGS,
    },
    path: "marketing-integrations",
    children: [
      {
        index: true,
        element: <IntegrationsHubRedirect to="../integrations" />,
      },
      {
        handle: {
          get breadcrumb() {
            return t("Orders API Documentation");
          },
          permission: SettingsPermissions.SET_MARKETING_SETTINGS,
        },
        path: "orders-api-documentation",
        lazy: async () => {
          const { OrdersApiDocumentation } =
            await import("../../../../setting/marketing/integrations/orders-api-documentation");
          return { Component: OrdersApiDocumentation };
        },
      },
    ],
  },
  {
    handle: {
      get breadcrumb() {
        return t("Keywords");
      },
      permission: SettingsPermissions.SET_MARKETING_SETTINGS,
    },
    path: "subscribe-keywords",
    lazy: async () => {
      const { SubscribeKeywordsTable } =
        await import("../../../../setting/marketing/subscribe-keywords/subscribe-keywords");
      return { Component: SubscribeKeywordsTable };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Marketing Agent");
      },
      permission: SettingsPermissions.SET_MARKETING_SETTINGS,
    },
    path: "marketing-agent",
    lazy: async () => {
      const { MarketingAgentSettingsPage } =
        await import("@redotech/redo-merchant-marketing-app/marketing-agent/marketing-agent-settings-page");
      return { Component: MarketingAgentSettingsPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Offer page configuration");
      },
      permission: SettingsPermissions.SET_MARKETING_SETTINGS,
    },
    path: "offer-page-configuration",
    lazy: async () => {
      const { OfferPageConfigurationPage } =
        await import("../../../../setting/marketing/offer-page-configuration");
      return { Component: OfferPageConfigurationPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Recover");
      },
      permission: SettingsPermissions.SET_MARKETING_SETTINGS,
    },
    path: "recover-settings",
    lazy: async () => {
      const { RecoverSettingsPage } =
        await import("../../../../setting/recover/recover-settings");
      return { Component: RecoverSettingsPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("SMS Marketing");
      },
      permission: SettingsPermissions.SET_MARKETING_SETTINGS,
    },
    path: "sms-marketing",
    lazy: async () => {
      const { SmsSettingsPage } =
        await import("../../../../setting/marketing/sms-settings");
      return { Component: SmsSettingsPage };
    },
  },
];
